import { useParams } from 'react-router-dom';
import './AnimalDetails.css';

export default function AnimalDetails() {
  const { id } = useParams();

  return (
    <div className="animal-details-page">
      <div className="animal-details-container">
        <h1>Животное #{id}</h1>
        <div className="animal-details-content">
          <p>Здесь будет информация о животном</p>
        </div>
      </div>
    </div>
  );
}
